import { render, staticRenderFns } from "./default-button.vue?vue&type=template&id=34a9a42d&scoped=true&"
import script from "./default-button.vue?vue&type=script&lang=js&"
export * from "./default-button.vue?vue&type=script&lang=js&"
import style0 from "./default-button.vue?vue&type=style&index=0&id=34a9a42d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a9a42d",
  null
  
)

export default component.exports